import {ThemeJsonPlugin, generateThemeJson} from './webpack-plugin';
import {transform} from './functions/transform';

module.exports = {ThemeJsonPlugin, generateThemeJson, transform};
